import { SxProps } from "@mui/material";

export const containerStyle: SxProps = {
  display: "flex",
  justifyContent: "space-evenly",
  alignItems: "center",
  paddingTop: "48px",
};

export const leftSectionStyle: SxProps = {
  width: "35%",
  justifyContent: "space-between",
};

export const promoImageStyle: SxProps = {
  height: "560px",
};

export const rightSectionStyle: SxProps = {
  width: "33%",
};

export const titleRowStyle: SxProps = {
  display: "flex",
  flexDirection: "row",
  paddingBottom: "16px",
};

export const titleTextStyle: SxProps = {
  fontWeight: 600,
  fontSize: "32px",
};

export const imageStyle: React.CSSProperties = {
  width: 40,
  height: 40,
  marginTop: "-4px",
};

export const descriptionTextStyle: SxProps = {
  fontSize: "16px",
  lineHeight: "32px",
  letterSpacing: 0.5,
  whiteSpace: "pre-wrap",
  color: "#828282",
};

export const signInButtonStyle: SxProps = {
  marginTop: "30px",
};

export const signUpButtonStyle: SxProps = {
  marginTop: 9,
};

export const subtitleTextStyle: SxProps = {
  textAlign: "center",
  marginBottom: 2,
  color: "#333333",
};
